import * as React from 'react';
import { useTranslation } from 'react-i18next';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  path: ReturnType<typeof require.context>;
}

const LocalizedImage: React.FC<Props> = ({ path, ...props }) => {
  const {
    i18n: { language },
  } = useTranslation();

  const images = path
    .keys()
    .filter((filename: any) => filename.startsWith(`./${language}`))
    .reduce(
      (result: any, filename: any) => {
        const url = path(filename);
        const size = filename.match(/@([^.]+)/);

        if (size) {
          result.srcSet.push(`${url} ${size[1]}`);
        } else {
          result.src = url;
        }
        return result;
      },
      { srcSet: [] }
    );

  images.srcSet = images.srcSet.join(', ');

  return <img {...images} {...props} />;
};

export default LocalizedImage;
